<template>
	<div class="min-h-screen bg-gray-50">
		<!-- css样式库 -->
		<link href="https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css" rel="stylesheet">
		<!-- 图标库 -->
		<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css">

		<!-- 左侧导航 -->
		<aside class="fixed left-0 top-0 h-screen w-64 bg-white border-r border-gray-200 overflow-y-auto">
			<div class="p-4 border-b border-gray-200">
				<div class="flex items-center gap-2">
					<img :src="logoUrl" alt="API文档" class="w-8 h-8 object-cover" />
					<h1 class="text-xl font-bold text-gray-800">API
						{{ $t('language000189') }}
					</h1>
				</div>
			</div>

			<el-menu default-active="1" class="el-menu-vertical-demo">
				<el-menu-item index="1" @click="toggleCategory(1)">
					<span slot="title">
						<!-- 介绍 -->
						{{ $t('language000193')}}
					</span>
				</el-menu-item>
				
				<el-menu-item index="8" @click="toggleCategory(8)">
					<span slot="title">
						<!-- 流程示意图 -->
						{{ $t('language000307')}}
					</span>
				</el-menu-item>

				<el-menu-item v-show="false" index="4" @click="toggleCategory(2)">
					<span slot="title">
						<!-- AES加密 -->
						{{ $t('language000226')}}
					</span>
				</el-menu-item>

				<!-- 平台调用 -->
				<el-submenu index="2">
					<template slot="title">
						<span>API Service</span>
					</template>
					<el-menu-item-group>
						<el-menu-item index="1-1" @click="toggleCategory(3)">
							<!-- API Token -->
							API Token
						</el-menu-item>
						
						<el-menu-item index="1-3" @click="toggleCategory(11)">
							<!--刷新 API Token -->
							{{ $t('language000282') }} API Token
						</el-menu-item>
						
						<el-menu-item index="1-2" @click="toggleCategory(7)">
							<!-- 平台绑定设备 -->
							{{ $t('language000286') }}
						</el-menu-item>
					</el-menu-item-group>
				</el-submenu>

				<!-- 蓝牙命令 -->
				<el-submenu index="3">
					<template slot="title">
						<span slot="title">
							<!-- 设备 -->
							{{ $t('language000279') }}
						</span>
					</template>
					<el-menu-item-group>
						<el-menu-item index="2-1" @click="toggleCategory(4)">
							<!-- 设备 Token -->
							{{ $t('language000190')}}
						</el-menu-item>
						<el-menu-item index="2-4" @click="toggleCategory(9)">
							<!-- 解密蓝牙命令 -->
							{{ $t('language000317')}}
						</el-menu-item>
						<el-menu-item index="2-2" @click="toggleCategory(5)">
							<!-- 开锁命令 -->
							{{ $t('language000191')}}
						</el-menu-item>
						<el-menu-item index="2-3" @click="toggleCategory(6)">
							<!-- 关锁命令 -->
							{{ $t('language000192')}}
						</el-menu-item>
						<el-menu-item index="2-5" @click="toggleCategory(10)">
							<!-- 查询已绑定设备信息 -->
							{{ $t('language000321')}}
						</el-menu-item>
					</el-menu-item-group>
				</el-submenu>
			</el-menu>
		</aside>

		<!-- 主内容区 -->
		<main class="ml-64 p-8">
			<introduce v-show="isIntroduce" />
			<steps v-show="isSteps" />
			<Aes v-show="isAes" />
			
			<getApiToken v-show="isGetApiToken" />
			<refreshApiToken v-show="isRefreshApiToken" />
			<BindingDevice v-show="isBindingDevice" />
			
			<getToken v-show="isGetToken" />
			<decryptionCommand v-show="isDecryptionCommand" />
			<getUnLock v-show="isGetUnLock" />
			<getLock v-show="isGetLock" />
			<getDeviceInfo v-show="isGetDeviceInfo" />
			
		</main>
	</div>
</template>

<script>
	import introduce from '../keybox01/item/introduce.vue'; //介绍
	import steps from '../keybox01/item/steps.vue'; //步骤介绍
	import Aes from '../current/Aes.vue'; //加解密

	import getApiToken from '../current/getApiToken.vue'; //获取ApiToken
	import refreshApiToken from '../current/refreshApiToken.vue'; //刷新ApiToken
	import BindingDevice from '../current/BindingDevice.vue'; //绑定设备

	import getToken from '../keybox01/item/getToken.vue'; //获取token
	import decryptionCommand from '../keybox01/item/decryptionCommand.vue'; //解密蓝牙命令
	import getUnLock from '../keybox01/item/getUnLock.vue'; //获取开锁命令
	import getLock from '../keybox01/item/getLock.vue'; //获取关锁命令
		import getDeviceInfo from '../current/getDeviceInfo.vue'; //查询设备信息

	export default {
		mounted() {
			const userLanguage = navigator.language || navigator.userLanguage; // 获取用户浏览器所配置的语言偏好
			const isLanguageSupported = this.$p_languages.includes(userLanguage); // 检查用户语言是否在支持的语言列表中
			this.$i18n.locale = isLanguageSupported ? userLanguage : this.$p_defaultLanguage; // 设置语言
		},
		components: {
			introduce,
			steps,
			Aes,
			getApiToken,
			refreshApiToken,
			BindingDevice,
			getToken,
			decryptionCommand,
			getUnLock,
			getLock,
			getDeviceInfo
		},
		computed: {},
		data() {
			return {
				isIntroduce: true,
				isSteps: false,
				isAes: false,
				isGetApiToken: false,
				isRefreshApiToken: false,
				isBindingDevice: false,
				isGetToken: false,
				isDecryptionCommand: false,
				isGetUnLock: false,
				isGetLock: false,
				isGetDeviceInfo: false,
				logoUrl: require('../../../../assets/app_logo.jpg'),
			};
		},
		methods: {
			toggleCategory(index) {
				this.isIntroduce = index === 1;
				this.isAes = index === 2;
				this.isGetApiToken = index === 3;
				this.isGetToken = index === 4;
				this.isGetUnLock = index === 5;
				this.isGetLock = index === 6;
				this.isBindingDevice = index === 7;
				this.isSteps = index === 8;
				this.isDecryptionCommand = index === 9;
				this.isGetDeviceInfo = index === 10;
				this.isRefreshApiToken = index === 11;
				

				window.scrollTo(0, 0); // 切换时回到顶部

			},
			//...
		},
	};
</script>

<style scoped>
</style>